


























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TimeLine from "@/components/classBuilder/TimeLine.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import StyleSelect from "@/components/form/StyleSelect.vue";
import TeacherSelect from "@/components/form/TeacherSelect.vue";
import {Level} from "@/models/Level";
import {get} from "@/context/context";
import {LevelsService} from "@/services/LevelsService";

@Component({
  components: {
    TeacherSelect,
    StyleSelect,
    CommonButton,
    TimeLine

  },
})
export default class HeaderSection extends Vue {
  private levelsService: LevelsService = get('levelsService');

  private levels:Array<Level> = [];
  private exercises:Array<any> = [];
  private musics:Array<any> = [];

  private style:string = '';
  private teacher:string = '';

  @Prop()
  private exersise?: string;

  @Watch('style')
  watchStyle() {
    this.$emit('selectStyle', this.style)
  }

  @Watch('teacher')
  watchTeacher() {
    this.$emit('selectTeacher', this.teacher)
  }

  private async mounted() {
    this.levels = await this.levelsService.getLevels();
    this.levels.sort((a, b) => a.level > b.level ? 1 : -1);
  }

  private handleCreateEvent() {
    let routeData = this.$router.resolve({name: 'create_event'});
    window.open(routeData.href, '_blank');
  }
}
